export default "__VITE_ASSET__Y3gp9tZ0KweSZ0Dya1OcxQ__"